export default __webpack_public_path__ + "static/media/Icon16.3c7b2280.svg";